import { render, staticRenderFns } from "./TagIDListCellLink.vue?vue&type=template&id=800aa2fa"
import script from "./TagIDListCellLink.vue?vue&type=script&lang=js"
export * from "./TagIDListCellLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports